import React from 'react';

import * as customPropTypes from '@/custom-prop-types';
import { Accordion as AccordionOriginal } from '@/design-system/atoms/Accordion';
import { Button } from '@/design-system/atoms/Button';
import { LinkListItem } from '@/design-system/atoms/LinkListItem';
import Typography from '@/design-system/atoms/Typography';

import { useTermFinderContext } from '../../stores/termFinderStore';
import styles from './Accordion.module.scss';

export const Accordion = ({ analytics }) => {
    const { eyebrow, showResultsButtonLabel } = useTermFinderContext((s) => s.uiCopy);

    const accordionItems = useTermFinderContext((s) => s.accordionItems);

    const onShowAllResults = useTermFinderContext((s) => s.onShowAllResults);
    const searchTerm = useTermFinderContext((s) => s.term);

    const handleViewAllClick = React.useCallback(
        (e) => {
            e.preventDefault();
            onShowAllResults();
        },
        [onShowAllResults],
    );

    const normalizedAccordionItems = React.useMemo(() => {
        return accordionItems?.map((accordionItem) => ({
            ...accordionItem,
            links: undefined,
            children: accordionItem.links.map((linkListItemProps, index) => (
                <LinkListItem
                    key={`${accordionItem.id}--${index}`}
                    classNameWrapper={styles['term-finder__link']}
                    {...linkListItemProps}
                    analytics={analytics ? { ...analytics, searchTerm: searchTerm } : undefined}
                />
            )),
        }));
    }, [accordionItems, analytics, searchTerm]);

    return (
        <>
            <div className={styles['term-finder__eyebrow']}>
                <Typography variant={Typography.VARIANT.E1} content={eyebrow} />
            </div>
            <AccordionOriginal
                accordionItems={normalizedAccordionItems}
                analytics={analytics ? { eventName: analytics.eventName } : undefined}
                noScrollLogic
            />
            <div className={styles['term-finder__view-all']}>
                <Button
                    label={showResultsButtonLabel}
                    buttonStyle={Button.STYLE.SECONDARY}
                    onClick={handleViewAllClick}
                    analytics={analytics ? { ...analytics, searchTerm: searchTerm } : undefined}
                />
            </div>
        </>
    );
};
Accordion.propTypes = {
    /**
     * analytics object
     */
    analytics: customPropTypes.analyticsPropType,
};
